import React from "react";
import { useAuth } from "helpers/use-auth";
import TransactionsTableWrapper from "../payment-manager/TransactionsTableWrapper";

export default function ShoppingOrders() {
  const auth = useAuth();
  return <TransactionsTableWrapper userId={auth.user.id} />;
}
